module.exports = __webpack_public_path__ + "static/img/c14.9c8ec57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c14.png
// module id = 107
// module chunks = 10